/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_GroupsInputs */



/**
* | output |
* | --- |
* | "Groups" |
*
* @param {Nav_GroupsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_groups = /** @type {((inputs?: Nav_GroupsInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_GroupsInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupes")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("小组")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("社團")
	if (locale === "ko") return /** @type {LocalizedString} */ ("그룹")
	return /** @type {LocalizedString} */ ("Groups")
});